import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';

type DistrictResponse = AxiosResponse<{
  id: number;
  country: string;
  value: string;
}>;

const useDistrictListQuery = (country: string) => {
  const query = useQuery<DistrictResponse>({
    queryKey: ['district-list', country],
    queryFn: () => API.get(`/config/country/${country}`),
    enabled: !!country,
  });

  return query;
};

export default useDistrictListQuery;
